import { IApplicationState } from '../../types/redux';

export const selectSuburbanBuildersAccountsList = (state: IApplicationState) => state.suburbanBuildersAccountsList;
